// Trainee "course language" selection — filters which language's courses are shown on the
// Explore feed and Topics list. Defaults to the language passed from the Loyalty app SSO
// (stored under `lms.locale`), then persists the learner's manual choice. Kept separate from
// the Devnagri UI-translation widget (that translates static UI text; this filters content).
import { useEffect, useState } from 'react';

const KEY = 'lms.course_lang';
const LOCALE_KEY = 'lms.locale';
const EVT = 'lms-course-lang';
const SUPPORTED = ['en', 'hi', 'ta', 'te', 'gu', 'bn', 'kn', 'ml', 'mr', 'or'];

// Doc Point 63: when the page is opened with a `?lang=<code>` query param (as passed from the
// Zeapl Loyalty app, e.g. /learn?lang=hi), adopt that language as the course language + locale.
// If no param is present, the existing default (en) stands. Called once on trainee-app load.
export function applyUrlLang() {
    try {
        const p = new URLSearchParams(window.location.search).get('lang');
        if (!p) return null;
        const l = p.toLowerCase();
        if (!SUPPORTED.includes(l)) return null;
        localStorage.setItem(LOCALE_KEY, l);
        setCourseLang(l);
        return l;
    } catch {
        return null;
    }
}

export function getCourseLang() {
    try {
        return localStorage.getItem(KEY) || localStorage.getItem(LOCALE_KEY) || 'en';
    } catch {
        return 'en';
    }
}

export function setCourseLang(lang) {
    try { localStorage.setItem(KEY, lang); } catch { /* ignore */ }
    window.dispatchEvent(new CustomEvent(EVT, { detail: lang }));
}

export function useCourseLang() {
    const [lang, setLang] = useState(getCourseLang);
    useEffect(() => {
        const h = (e) => setLang((e && e.detail) || getCourseLang());
        window.addEventListener(EVT, h);
        return () => window.removeEventListener(EVT, h);
    }, []);
    return [lang, setCourseLang];
}
